import CouponCard from './CouponCard';

export default CouponCard;
